let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iI0Na")).then(() => parcelRequire('3kI8N'));